import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';

export const supportedLngs = ['lt', 'en', 'ru', 'de'];

i18n
  .use(HttpApi)
  .use(initReactI18next)
  .init({
    lng: 'lt',
    fallbackLng: 'lt',
    supportedLngs: supportedLngs,
    ns: ['translation'],
    defaultNS: 'translation',

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json?_t=' + Date.now()
    },

    debug: false,

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;